import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { TextField, Button, Typography, Box, Alert } from '@mui/material';
import AuthShell from './Auth/AuthShell';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [confirmationSuccess, setConfirmationSuccess] = useState(false);
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.confirmationSuccess) {
      setConfirmationSuccess(true);
    }
  }, [location]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoginError('');

    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        login(data.token, data.role);
      } else {
        setLoginError('Inicio de sesión fallido. Por favor verifica tus credenciales.');
      }
    } catch (error) {
      setLoginError('Error al conectar con el servidor...');
    }
  };

  return (
    <AuthShell eyebrow="BIENVENIDO DE NUEVO" title="Iniciar sesión" subtitle="Retoma tu planificación y sigue avanzando a tu ritmo.">
        {confirmationSuccess && (
          <Alert severity="success" sx={{ mt: 2, mb: 2 }}>
            ¡Cuenta confirmada con éxito! Por favor, inicia sesión.
          </Alert>
        )}
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Correo Electrónico"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Contraseña"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {loginError && <Alert severity="error">{loginError}</Alert>}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Iniciar sesión
          </Button>
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Link to="/cambiar-contrasena" style={{ textDecoration: 'none' }}>
              <Typography variant="body2" color="primary">
                ¿Olvidaste tu contraseña? Haz clic aquí para cambiarla
              </Typography>
            </Link>
          </Box>
          <Typography variant="body2" align="center" sx={{ mt: 2 }}>
            ¿No tienes una cuenta?{' '}
            <Link to="/registro" style={{ textDecoration: 'underline', fontWeight: 'bold', color: '#667eea' }}>
              Regístrate aquí
            </Link>
          </Typography>
        </Box>
    </AuthShell>
  );
};

export default Login;
